<ng-container *ngIf="googleIcons">
  <span class="icon material-icons">{{ gIcon }}</span>
</ng-container>
<ng-container *ngIf="!googleIcons">
  <span class="icon {{ icon }}"></span>
</ng-container>
